import { filter, last } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import RequestToolbar from 'src/components/_dashboard/user/list/RequestToolbar';
import CustomerOrderMenu from 'src/components/_dashboard/user/list/CustomerOrderMenu.js';
import moment from 'moment';
import { getAgoString, getStatusColorAndLabel } from 'src/common/Helper';
import { COMPANY_NAME } from 'src/constants/Defaultvalues';

// ----------------------------------------------------------------------

const TABLE_HEAD = [

  { id: 'req-status', label: 'Order Status', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'type', label: 'Last Updated', alignRight: false },
  // { id: 'address', label: 'Partner Status', alignRight: false },
  // { id: 'status', label: 'Partner Status', alignRight: false },
  { id: 'options'}
];
const TABLE_HEAD_TEAM_MEMBERS = [
  { id: 'status' },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'type', label: 'Request Type', alignRight: false },
  { id: 'address', label: 'Last Updated', alignRight: false },
  { id: 'options'}
];



// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis?.map((el) => el[0]);
}

const onboard_data = [
  {
    id: 0,
    name: 'quote 1000',
    type: "RFQ",
    lastupdate: "2 Months ago",
    status: "Accepted",
    awarded: "Awarded"
  },
  {
    id: 1,
    name: 'Quote 101',
    type: "RFQ",
    lastupdate: "2 Months ago",
    status: "Accepted",
    awarded: "Awarded"
  },
  {
    id: 2,
    name: 'quote 100',
    type: "RFQ",
    lastupdate: "2 Months ago",
    status: "Accepted",
    awarded: "Awarded"
  },
  {
    id: 3,
    name: 'quote 11',
    type: "RFQ",
    lastupdate: "2 Months ago",
    status: "Accepted",
    awarded: "Awarded"
  },
]

const requestType = {
  1: "Assignment",
  2: "RFP",
  3: "RFI"
}


const requestState = {
  1: "Draft",
  2: "Open",
  3: "Evaluating",
  4: "Awarded",
  5: "Closed"
}


const requestColour = {
  1: "warning",
  2: "success",
  3: "info",
  4: "secondary",
  5: "error"
}


const partnerStatus = {
  0: "Unseen",
  1: "Accepted",
  2: "Rejected"
}



export default function Request({ receivedId, requests, isTeam,isClient,clientId }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const Request = requests  // Replaced Request with onboard_data
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate()
  const userData = JSON.parse(localStorage.getItem('user'));
  let explodedPermissions = userData?.exploded_permissions

  if (isClient) {
    console.log("isTeam *********- ", isTeam)
    console.log('-------------------',requests)
    console.log("receivedId *******- ", receivedId)
  }


  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Rest of the code remains unchanged from here
  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = Request?.map((n) => n.request_id||n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - Request?.length) : 0;

  const filteredUsers = applySortFilter(Request, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers?.length === 0;

  return (
    <Page title={`Request |${COMPANY_NAME}`}>
      <Container>
        {/* <HeaderBreadcrumbs
          heading="User List"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'User', href: PATH_DASHBOARD.user.root },
            { name: 'List' }
          ]}
          action={
            <Button
              variant="contained"
              component={RouterLink}
              to={PATH_DASHBOARD.user.newUser}
              startIcon={<Icon icon={plusFill} />}
            >
              New User
            </Button>
          }
        /> */}

        <Card>

          <RequestToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={isTeam ? TABLE_HEAD_TEAM_MEMBERS : TABLE_HEAD}
                  rowCount={Request?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  
                    const id = isTeam ?row.request_id:row.id;
                    const name = row.name;
                    const awarded = isTeam ? null : row.awarded;
                    const status = isTeam ? requestState[row.request_status] : row.status;
                    const statusColor = isTeam ? requestColour[row.request_status] : null;
                    const type = isTeam ? requestType[row.type] : row.type;
                    const lastupdate = isTeam ? row.timestamp : getAgoString(row.timestamp) ;
                    const isItemSelected =  selected.indexOf(isTeam ?row.request_id:row.id) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >

                        <TableCell padding="checkbox">
                        {userData.user_type ==1 ? 
                         <Checkbox checked={isItemSelected} onChange={(event) => {handleClick(event, id)}} />
                         :
                         ""
                        }
                        </TableCell>
                        <TableCell align="center">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={isTeam ? statusColor : getStatusColorAndLabel(status).color || 'success'}
                          >
                        {getStatusColorAndLabel(status).label}
                      </Label>
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell>
                        {/* <TableCell align="center">{type}</TableCell> */}
                        <TableCell align="center">{lastupdate}</TableCell>

                        {/* {!isTeam && <TableCell align="center">
                        <Label
                         variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                         color={getStatusColorAndLabel(type).color}
                              >
                         {getStatusColorAndLabel(type,
                          row.installationStatus,
                          row.allInstallationCompleted,
                          row.installation_acceptance,
                          row.min_payment_status,
                          row.billing_type,
                          row.CommunityJob,
                          row.project_category ).label}
                      </Label>
                        </TableCell>} */}
                        
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            disabled={explodedPermissions?.some(permission => ['Create Request', 'Edit Request', 'Delete request','Add vendor to request','Add client to request'].includes(permission)) ? false : true}
                            // component={RouterLink}
                            onClick={()=>navigate(`/dashboard/official-request/view/${id}`)}
                            // onClick={navigate(`/dashboard/official-request/view/${id}`)}
                            // to={`${PATH_DASHBOARD.client.requests}?id=${id}/view`}
                          >
                            View
                          </Button>
                        </TableCell>


                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Requests" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50,100]}
            component="div"
            count={Request?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
